<template>
  <div>
    <div :style="{ fontSize: fonts.font30 + 'px' }"
         id="header"
         >Pay Your Bills Online</div>
    <div id="bpInstructions">
      Click the Continue button to open the Bill Pay site in a separate window.<br />
      If your browser has a pop-up blocker, you may need to disable it
      for this web site.<br />
      If you haven't registered for Bill Pay yet, you will be presented
      with a Sign-Up page.<br />&nbsp;
    </div>
    <div id="bottom">
      <portal-target name="bpPortal"></portal-target>
      <b-button-group>
        <b-button :class="{disabled: !continueEnabled}"
                  id="btnContinue"
                  @click="bpContinue">
          Continue
        </b-button>
        <b-button class="btnCan"
                  name="btnCancel"
                  ref="btnCancel"
                  @click="cancel">
          Cancel
        </b-button>
        <!-- <b-button id="btnHelp"
                  name="btnHelp"
                  ref="btnHelp"
                  @click="help">
          Help
        </b-button> -->
      </b-button-group>
    </div>
    <portal to="bpPortal">
      <div id="bpProvider">{{bp.provider}}</div>
    </portal>
  </div>
</template>

<script>
// import axios from 'axios';
import utl from '../myUtils';

export default {
  name: 'billPay',
  data() {
    return {
      myVar: '1',
    };
  },
  watch: {
  },
  computed: {
    fonts() {
      return this.$store.getters.getFonts;
    },
    cun() {
      return this.$store.getters.getCuNumber;
    },
    member() {
      return this.$store.getters.getMember;
    },
    bp() {
      return this.$store.getters.getBillPayVars;
    },
    continueEnabled() {
      return this.$store.getters.getBillPayContinueEnabled;
    },
  },
  methods: {
    bpContinue() {
      if (this.continueEnabled === true) {
        const mapForm = document.createElement('form');
        mapForm.target = 'Map';
        mapForm.method = 'POST'; // Use POST for Ipay

        if (this.bp.provider === 'coop') {
          mapForm.method = 'GET'; // Use GET for COOP
        }

        mapForm.action = this.bp.url;
        const data = this.bp.params;
        Object.keys(data).forEach((key) => {
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = key;
          input.value = data[key];
          // utl.diag(`Param: ${key}=${data[key]}`);
          mapForm.appendChild(input);
        });
        document.body.appendChild(mapForm);
        const map = window.open('', 'Map');
        if (map) {
          mapForm.submit();
          window.history.back();
        } else {
          utl.diag('Please disable your Popup blocker.');
        }
      } else {
        // Continue Button not enabled yet
      }
    },
    cancel() {
      window.history.back();
    },
  },
};
</script>

<style scoped>
  #header {
    color: red;
  }
  #bpInstructions {
    padding-left: 8px;
    padding-right: 8px;
  }
  #bottom {
    /* position: absolute; */
  }
  #btnContinue {
    background-color: lime;
    color: black;
    font-weight: bold;
    margin-right: 5px;
  }
  .btnCan {
    background-color: red;
    color: black;
    font-weight: bold;
    margin-left: 5px;
  }
  #bpProvider {
    position: absolute;
    font-size: 8px;
    bottom: 10px;
    left: 4px;
  }
</style>



// WEBPACK FOOTER //
// src/components/billPay.vue